<template>
    <main>
        <section v-for="(activity, activityIndex) in project.activities"
                 class="box"
                 :key="activityIndex"
                 v-if="activity.title != null"
        >
            <div class="field is-horizontal">
                <div class="field-label">
                    <label class="label">กิจกรรมที่ {{ activityIndex + 1}}</label>
                </div>
                <div class="field-body">
                    <p>{{ activity.title }}</p>
                </div>
            </div>
            <div class="field is-horizontal">
                <div class="field-label">
                    <label class="label">จังหวัด</label>
                </div>
                <div class="field-body">
                    <p>{{ activity.province }}</p>
                </div>
            </div>
            <div class="field is-horizontal">
                <div class="field-label">
                    <label class="label">ระยะเวลาดำเนินกิจกรรม</label>
                </div>
                <div class="field-body">
                    <p class="control">
                        {{ activity.start_date | date }}
                        ถึง
                        {{ activity.end_date | date }}
                    </p>
                </div>
            </div>
            <div class="field">
                <table class="table is-fullwidth is-borderless is-countable is-marginless"
                       v-if="activity.expenses.length > 0">
                    <thead>
                    <tr>
                        <th>ลำดับ</th>
                        <th>หมวด</th>
                        <th>ประเภท</th>
                        <th class="is-expanded">รายการ</th>
                        <th class="is-expanded">อัตรา</th>
                        <th class="has-text-right" style="width: 150px">จำนวนเงิน</th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <template v-for="(expense, expenseIndex) in activity.expenses">
                        <tr>
                            <td class="is-counter is-narrow"></td>
                            <td class="is-narrow">
                                <strong v-if="showCategory(activity, expenseIndex)">
                                    {{ expense.category }}
                                </strong>
                            </td>
                            <td class="is-narrow">
                                {{ expenseType(activity, expenseIndex) }}
                                <input type="hidden"
                                       :name="'expenses[' + activityIndex + '][' + expenseIndex + '][id]'"
                                       v-model="expense.id"
                                />
                                <input type="hidden"
                                       :name="'expenses[' + activityIndex + '][' + expenseIndex + '][parameter_id]'"
                                       v-model="expense.parameter_id"
                                />
                            </td>
                            <td>
                                <textarea class="textarea"
                                          rows="1"
                                          v-autosize
                                          :name="'expenses[' + activityIndex + '][' + expenseIndex + '][title]'"
                                          v-model="expense.title"
                                ></textarea>
                            </td>
                            <td>
                                <textarea class="textarea"
                                          rows="1"
                                          v-autosize
                                          :name="'expenses[' + activityIndex + '][' + expenseIndex + '][rate]'"
                                          v-model="expense.rate"
                                          @keyup="calculateBudget(expense)"
                                ></textarea>
                            </td>
                            <td>
                                <input type="number"
                                       class="input has-text-right"
                                       :name="'expenses[' + activityIndex + '][' + expenseIndex + '][budget]'"
                                       v-model.number="expense.budget"
                                       min="0"
                                       @click="$event.target.select()"
                                />
                            </td>
                            <td class="is-narrow">
                                <span class="delete"
                                      tabindex="-1"
                                      @click.prevent="deleteExpense(activityIndex, expenseIndex)"></span>
                            </td>
                        </tr>
                    </template>
                    </tbody>
                    <tfoot v-if="totalActivityExpenses(activity) > 0">
                    <tr>
                        <td colspan="5" class="has-text-right is-bold">รวม</td>
                        <td class="has-text-right is-bold">{{ totalActivityExpenses(activity) | numeral }}</td>
                        <td></td>
                    </tr>
                    <tr>
                        <td colspan="6" class="has-text-right is-bold">({{ totalActivityExpenses(activity) |
                            thaibaht }})
                        </td>
                        <td></td>
                    </tr>
                    </tfoot>
                </table>

            </div>
            <div class="field is-horizontal">
                <div class="field-label">
                    <label class="label">เลือกค่าใช้จ่าย</label>
                </div>
                <div class="field-body">
                    <div class="select">
                        <select v-model="selectedExpenseIds[activityIndex]" @change="selectExpense(activityIndex)">
                            <option value=""></option>
                            <optgroup v-for="(group, category) in expenseOptions"
                                      :label="category"
                            >
                                <option v-for="parameter in group"
                                        :value="parameter.id"
                                >
                                    {{ parameter.title }}
                                </option>
                            </optgroup>
                        </select>
                    </div>
                </div>
            </div>
        </section>
        <section class="mt-2">
            <div class="box">
                <div class="text-xl flex lg:w-1/2">
                    <div class="flex-grow">
                        งบประมาณที่ได้รับอนุมัติ
                    </div>
                    <strong v-if="project.approve_budget > 0"
                            class="text-purple">
                        {{ project.approve_budget | numeral }}
                    </strong>
                    <span v-else>-&nbsp;</span>
                    บาท
                </div>
                <div class="text-xl flex lg:w-1/2">
                    <div class="flex-grow">

                        รวมงบประมาณที่ใช้ในโครงการ
                    </div>
                    <strong class="text-purple">{{ totalExpenses() | numeral }} บาท</strong>
                </div>
                <div class="text-lg flex justify-end lg:w-1/2">
                    <strong>({{ totalExpenses() | thaibaht }})</strong>
                </div>

            </div>
        </section>
    </main>
</template>
<script type="text/babel">

    export default {
        props: {
            project: {type: Object, required: true},
        },

        data() {
            return {
                expenses,
                selectedExpenseIds: []
            }
        },
        computed: {
            expenseOptions() {
                return _.groupBy(this.expenses, 'category');
            }
        },
        mounted() {
            this.$watch('project.activities', () => this.init());
            this.init();
        },
        methods: {
            init() {
                _.each(this.project.activities, (activity, index) => {
                    if (activity.expenses === undefined) {
                        activity.expenses = [];

                        this.$set(this.project.activities, index, activity);
                        this.selectedExpenseIds.push(null);
                    }
                });
            },
            selectExpense(activityIndex) {
                let parameter_id = this.selectedExpenseIds[activityIndex];
                if (!parameter_id) return;


                let parameter = _.find(this.expenses, {'id': parameter_id});

                this.project.activities[activityIndex].expenses.push({
                    id: null,
                    parameter_id: parameter_id,
                    type: parameter.title,
                    category: parameter.category,
                    seq: parseInt(parameter.seq),
                    title: null,
                    rate: null,
                    budget: null,
                });
                this.project.activities[activityIndex].expenses = _.sortBy(this.project.activities[activityIndex].expenses, 'seq');

                this.selectedExpenseIds[activityIndex] = null;
            },
            deleteExpense(activityIndex, expenseIndex) {
                this.$delete(this.project.activities[activityIndex].expenses, expenseIndex);
                this.$forceUpdate();
            },
            expenseType(activity, expenseIndex) {
                if (expenseIndex === 0) {
                    return activity.expenses[expenseIndex].type;
                }

                if (activity.expenses[expenseIndex].category != activity.expenses[expenseIndex - 1].category) {
                    return activity.expenses[expenseIndex].type;
                }

                return activity.expenses[expenseIndex].type != activity.expenses[expenseIndex - 1].type ?
                    activity.expenses[expenseIndex].type :
                    '';
            },

            showCategory(activity, expenseIndex) {
                if (expenseIndex === 0) {
                    return true;
                }

                return activity.expenses[expenseIndex].category != activity.expenses[expenseIndex - 1].category;
            },
            totalActivityExpenses(activity) {
                return _.sumBy(activity.expenses, (expense) => {
                        return expense.budget != '' ?
                            expense.budget :
                            0
                    }
                );
            },
            totalExpenses() {
                return _.sumBy(this.project.activities, (activity) => this.totalActivityExpenses(activity));
            },
            calculateBudget(expense) {

                if (expense.rate === null || expense.rate.length === 0) {
                    return;
                }

                let numbers = expense.rate.replace(',', '').match(/([0-9\.]+)\b/g);

                if (numbers === null || numbers.length === 0) {
                    return;
                }

                expense.budget = _.reduce(numbers, (multiply, n) => {
                    return multiply * n
                }, 1);
            }
        }
    }
</script>